var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserHeadset20 = function SvgUserHeadset20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M8.187 7.115a.83.83 0 0 0 .604-.26c.618-.65 1.72-.675 2.363-.054a.833.833 0 0 0 1.158-1.2A3.31 3.31 0 0 0 10 4.668c-.91 0-1.791.38-2.418 1.04a.834.834 0 0 0 .605 1.407"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M15.833 8.001A5.84 5.84 0 0 0 10 2.168a5.84 5.84 0 0 0-5.833 5.833 2.503 2.503 0 0 0-2.5 2.5v1.667c0 1.378 1.121 2.5 2.5 2.5H5c.46 0 .833-.373.833-.833V8A4.17 4.17 0 0 1 10 3.835 4.17 4.17 0 0 1 14.166 8v5.903c0 1.34-1.09 2.43-2.43 2.43h-.07c0-.918-.747-1.666-1.666-1.666h-.834c-.919 0-1.666.748-1.666 1.667v.833c0 .92.747 1.667 1.666 1.667H10c.614 0 1.146-.338 1.435-.834h.3a4.1 4.1 0 0 0 4.02-3.333h.078c1.379 0 2.5-1.122 2.5-2.5v-1.667c0-1.378-1.121-2.5-2.5-2.5"
  })));
};
export default SvgUserHeadset20;